import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../Layout';
import Paper from '../../presentational/Paper';

const items = [
  { type: 'p', content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum.' },
  { type: 'h4', content: 'Choose a plan first', style: 'subtitle is-5 dark-text' },
  { type: 'p', content: 'Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.' },
  { type: 'ul', items: [
      { content: 'Discovery pricing' },
      { content: 'Business pricing' },
    ]
  },
  { type: 'h4', content: 'Activate your account', style: 'subtitle is-5 dark-text' },
  { type: 'p', content: 'Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.' },
  { type: 'p', content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum.' },
  { type: 'h4', content: 'Perform initial setup', style: 'subtitle is-5 dark-text' },
  { type: 'p', content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum.' },
  { type: 'ul', items: [
      { content: 'Create a company' },
      { content: 'Add users to your team' },
      { content: 'Start working' },
    ]
  },
];

const crumbs = [
  { content: 'Dokümanlar', url: '/Documents' },
  { content: 'ERP Giriş', url: '/DocumentCategory/5' },
  { content: 'Neden ERP?'},
];

const meta = {avatarUrl: 'https://via.placeholder.com/250x250', author: 'Azerhan Özen',timeStamp: '1 hafta önce'};
export default class Document extends Component {
  render() {
    return(
      <Layout>
        <Paper
          title="Neden ERP?"
          subtitle="Kararınızı vermeden bir kez daha düşünün :)"
          items={items}
          crumbs={crumbs}
          meta={meta}
          rating={true}
        />
      </Layout>
    );
  }
};
